import { i as n } from "./index.es268.js";
var i = n, t = Object.create, c = /* @__PURE__ */ function() {
  function e() {
  }
  return function(r) {
    if (!i(r))
      return {};
    if (t)
      return t(r);
    e.prototype = r;
    var a = new e();
    return e.prototype = void 0, a;
  };
}(), o = c;
export {
  o as _
};
//# sourceMappingURL=index.es397.js.map
